import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { H1 } from '@expo/html-elements';
import type { AddressType } from '@sweetgreen/garnish';
import { SPACING, TitleText, useResponsive } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const CheckoutHeader = (props: CheckoutScreenHeaderProps) => {
  const { style, orderType, ...restProps } = props;

  const { t } = useLocalizationContext();
  const { match, minWidth } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const headerStyle = [
    match([styles.headerMobile, styles.headerTabletUp]),
    style,
  ];
  const headingStyles = [
    styles.heading,
    minWidth.tablet ? styles.headingSM : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  const orderTypeBasedHeading = t(`checkout.finish-order-${orderType}`);

  return (
    <View style={headerStyle} {...restProps}>
      <H1 style={headingStyles}>
        <TitleText size={match([3, 4])} style={headingStyles}>
          {orderTypeBasedHeading}
        </TitleText>
      </H1>
    </View>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

type CheckoutScreenHeaderProps = {
  readonly orderType: AddressType;
} & Omit<ViewProps, 'children'>;

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerMobile: {
    paddingBottom: SPACING.xlarge,
  },
  headerTabletUp: {
    paddingVertical: SPACING.xlarge,
  },
  heading: {
    marginVertical: 0,
  },
  headingSM: {
    textAlign: 'center',
    marginVertical: 0,
  },
});
